export default __webpack_public_path__ + "static/media/7-3.539224d1.mp3";